// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"31":"fc30e591","405":"eb0b7f66","614":"c543fbd6","678":"29bf9378","908":"217a4232"}[chunkId] + ".css";
};